export type LoadFailureReason =
  | "scripts_blocked_or_disabled"
  | "load_timeout"
  | "script_load_error"
  | "main_module_error"
  | "react_mount_error";

export const LOAD_FAILURE_REASON_LABELS: Record<LoadFailureReason, string> = {
  scripts_blocked_or_disabled: "Scripts blocked or disabled",
  load_timeout: "App load timeout (12s)",
  script_load_error: "Script or stylesheet failed to load",
  main_module_error: "Main application bundle failed to load",
  react_mount_error: "React failed to mount",
};

const SESSION_KEY_PREFIX = "bige_load_failure_logged_";

export function logLoadFailure(reason: LoadFailureReason, detail?: string): void {
  const sessionKey = `${SESSION_KEY_PREFIX}${reason}`;
  if (sessionStorage.getItem(sessionKey)) return;
  sessionStorage.setItem(sessionKey, "1");

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!supabaseUrl || !anonKey) return;

  fetch(`${supabaseUrl}/functions/v1/log-load-failure`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: anonKey,
      Authorization: `Bearer ${anonKey}`,
    },
    body: JSON.stringify({
      reason,
      detail: detail ?? null,
      page_path: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    }),
    keepalive: true,
  }).catch(() => {});
}
